"use client";

import { Spinner } from "@material-tailwind/react";

export default function Loading() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner className="h-12 w-12 text-secondary" {...({} as any)} />
    </div>
  );
}
